import { useTranslation } from '@frontend/i18n';
import { usePopoverMenu } from '@frontend/design-system';
import { InboxFiltersPopoverSubmenuItem } from '../inbox-filters-popover-submenu-item';
import { AiReceptionistFilterPopoverMenu } from './ai-receptionist-filter-popover-menu';

type AiReceptionistFilterPopoverSubmenuItemProps = {
  toggleItems: (aiStatuses: string[]) => void;
  selectedAiStatuses: string[];
  groupIds?: string[];
  divider?: 'top' | 'bottom';
  trackingId?: string;
};

export const AiReceptionistFilterPopoverSubmenuItem = ({
  toggleItems,
  selectedAiStatuses,
  groupIds,
  divider,
  trackingId,
}: AiReceptionistFilterPopoverSubmenuItemProps) => {
  const { t } = useTranslation('inbox');
  const aiReceptionistPopover = usePopoverMenu<HTMLButtonElement>({
    placement: 'right-start',
    middlewareOptions: {
      offset: {
        mainAxis: 0,
        crossAxis: -8,
      },
    },
  });

  return (
    <>
      <InboxFiltersPopoverSubmenuItem
        getSubmenuTriggerProps={aiReceptionistPopover.getTriggerProps}
        iconName='aiassistant'
        label={t('Ai Receptionist')}
        count={selectedAiStatuses.length}
        divider={divider}
        trackingId={trackingId}
      />
      <AiReceptionistFilterPopoverMenu
        getMenuProps={aiReceptionistPopover.getMenuProps}
        getItemProps={aiReceptionistPopover.getItemProps}
        groupIds={groupIds}
        toggleItems={toggleItems}
        selectedAiStatuses={selectedAiStatuses}
      />
    </>
  );
};
